import React from 'react';

import { css } from 'config/emotionCss';

import LazyLoader from 'ui/layout/LazyLoader';

const BasePdfViewer = React.lazy(() => import('ui/base/PDFViewer'));

const pdfViewerStyle = css`
  min-width: 640px;
`;

const wrapperStyle = css`
  max-height: calc(100svh - 70px);
`;

/** @type {React.FC<{ url: string }>} */
const PdfViewer = ({ url }) => {
  const [page, setPage] = React.useState(1);
  const handlePageChange = React.useCallback((pageNumber) => setPage(pageNumber), []);

  return (
    <LazyLoader>
      <BasePdfViewer
        file={url}
        page={page}
        setPage={handlePageChange}
        className={pdfViewerStyle}
        wrapperClassName={wrapperStyle}
      />
    </LazyLoader>
  );
};

export default PdfViewer;
